var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRanking = function SvgRanking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 11,
    x: 6,
    y: 37,
    fill: "#FFD2A8",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 11,
    x: 10,
    y: 52,
    fill: "#FFEBD9",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M3 10a2 2 0 0 1 2-2h60a2 2 0 0 1 2 2v21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm59.083 5.797a1.5 1.5 0 0 1 0 2.122l-7.164 7.164a1.5 1.5 0 0 1-2.122 0l-3.858-3.858a1.5 1.5 0 1 1 2.122-2.121l2.797 2.797 6.104-6.104a1.5 1.5 0 0 1 2.121 0M10 12.5a1.5 1.5 0 0 0 0 3h27a1.5 1.5 0 0 0 0-3zM8.5 20a1.5 1.5 0 0 1 1.5-1.5h31a1.5 1.5 0 0 1 0 3H10A1.5 1.5 0 0 1 8.5 20m1.5 4.5a1.5 1.5 0 0 0 0 3h25a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })));
};
export default SvgRanking;